import React from 'react';
// import {Link} from 'react-router-dom';
import '../../css/Attendee.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import NavbarComp from './Navbar.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInstagramSquare, faFacebookSquare, faTwitterSquare} from '@fortawesome/free-brands-svg-icons'; 

export default function AttendeeHeader () {
return(
<section className='top-nav'>
<div className='container'>
    <div className='row'>
        <div className='col-12 col-md-6'>
            <div className='logo'>
            <img src={process.env.PUBLIC_URL+'/assets/logo.png'}/>
            </div>
        </div>
        <div className='col-12 col-md-6 center'>
            <div className='social-media'>
                <ul>
                    <li>
                    <FontAwesomeIcon icon={faInstagramSquare} />
                    </li>
                    <li>
                    <FontAwesomeIcon icon={faFacebookSquare} />
                    </li>
                    <li>
                    <FontAwesomeIcon icon={faTwitterSquare} />
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div>
        <NavbarComp/>
    </div>

<div>

</div>
</div>

</section>
)

}